import { Comment, Identifiable } from "@planzone/dto";

function extractReplyToUuid(
  comment: Identifiable<Comment>,
): string | undefined {
  if (comment.replyTo) return comment.replyTo.uuid;
  const href = (comment as any)._links?.replyTo?.href as string | undefined;
  if (href) return href.split("/").pop();
  return undefined;
}

function resolveReplies(
  comments: Identifiable<Comment>[],
): Identifiable<Comment>[] {
  return comments.map((comment) => {
    const replyToUuid = extractReplyToUuid(comment);
    if (!replyToUuid) return comment;
    const parent = comments.find((c) => c.uuid === replyToUuid);
    return parent ? { ...comment, replyTo: parent } : comment;
  });
}

export { resolveReplies };
